import { TChangeLogs } from '@/containers/UpdateContainer/UpdateContainer.types';

const changelogs: TChangeLogs = {
  '0.8.0': [
    'افزودن امکان درخواست مشاوره رایگان صندوق‌های سرمایه گذاری',
    'افزودن جزئیات صندوق‌های سرمایه گذاری',
    'بهبود تجربه کاربری صندوق‌های سرمایه گذاری',
    '...',
  ],
  '0.9.1': [
    'افزودن امکان خرید صندوق‌های سرمایه گذاری',
    'رفع مشکل باز شدن بورس ویو ',
    'اصلاح نحوه نمایش امتیاز پلکان',
    'بهبود نمایش امتیاز پلکان',
  ],
  '0.9.2': ['رفع مشکل عدم نمایش جزئیات صندوق در برخی از گوشی ها'],
  '0.9.3': [
    'افزودن جزئیات تراکنش‌های صندوق های سرمایه گذاری',
    'افزودن امکان لغو خرید واحدهای صندوق',
    'رفع خطای ثبت درخواست‌های پشتیبانی برای برخی از کاربران',
    'بهبود تجربه کاربری بخش سهام و رفع خطای عدم نمایش کلیه نمادها',
    'بهبود عملکرد و رفع برخی از ایرادات جزئی',
  ],
  '0.11.0': ['بهبود عملکرد و رفع ایرادات جزئی'],
  '0.12.0': [
    'افزودن امکان فروش واحدهای صندوق‌های سرمایه گذاری',
    'افزودن بازده یک ماهه صندوق‌های سرمایه گذاری',
    'رفع مشکل عدم نمایش بخش سرمایه گذاری برای برخی از کاربران ',
    'بهبود فرایند ثبت درخواست مشاوره',
    'بهبودهای امنیتی',
    'بهبود عملکرد و رفع ایرادات جزئی',
  ],
  '0.13.0': [
    'افزودن امکان دریافت و فعالسازی مفید کارت (قابلیت برداشت وجه آنی از موجودی کارگزاری)',
    'بهبود عملکرد و رفع ایرادات جزئی',
  ],
  '0.14.0': [
    'بهبود تجربه کاربری تراکنش های صندوق‌های سرمایه گذاری',
    'بهبود عملکرد و رفع ایرادات جزئی',
  ],
  '0.15.2': [
    'رفع مشکل مفید کارت و نمایش مانده کارگزاری برای برخی از کاربران جدید',
    'بهبود تجربه کاربری مفید کارت',
    'بهبود تجربه کاربری خرید و فروش صندوق های سرمایه گذاری',
    'بهبود عملکرد و رفع ایرادات جزئی',
  ],
  '1.0.9': [
    'بازطراحی کامل رابط کاربری',
    'افزودن امکان واریز و برداشت وجه به حساب کارگزاری',
    'افزودن بخش مدیریت مالی برای مشاهده و مدیریت یکپارچه تمامی دارایی ها',
    'رفع برخی ایرادات براساس بازخورد های کاربران',
  ],
  '1.0.12': [
    'رفع مشکل نصب و اجرا برای برخی از کاربران گوشی های سامسونگ و هوآوی',
    'افزایش سقف واریز به کارگزاری به صد میلیون تومان',
    'بهبود عملکرد و افزایش سرعت',
    'بهبود رابط کاربری براساس بازخورد های کاربران',
  ],
  '1.0.13': [
    'اضافه شدن بخش تنظیمات مفید کارت',
    'قابلیت بازیابی رمز اول کارت',
    'امکان درخواست المثنی در صورت مفقودی کارت',
    'امکان درخواست مسدود سازی کارت',
  ],
  '1.0.14': [
    'اضافه شدن نمودار تغییرات دارایی در صندوق‌ها',
    'اضافه شدن نمودار تغییرات قیمت ‌صندوق‌ها',
    'اضافه شدن نمودار‌های مقایسه‌ای در بخش صندوق‌ها',
    'اضافه شدن جزئیات و نمودار‌های مقایسه‌ای در بخش سبد سهام',
    'رفع ایرادات تراکنش های صندوق‌های سرمایه گذاری',
    'بهبود رابط کاربری',
    'رفع ایرادات جزئی',
  ],
  '1.0.15': ['بهبود نمایش تراکنش های هر صندوق', 'رفع ایرادات جزئی'],
  '1.0.16': [
    'اضافه شدن امکان واریز مبلغ فروش صندوق ها به حساب کارگزاری',
    'اضافه شدن امکان تعریف کد امنیتی و اثر انگشت برای ورود به اپلیکیشن',
    'اضافه شدن نمودار تغییرات ارزش دارایی برای مجموع دارایی صندوق‌ها',
    'نمایش تعداد واحد های وثیقه صندوق های سرمایه گذاری',
    'بهبود رابط کاربری و رفع ایرادات جزیی',
  ],
  '1.0.17': [
    'اضافه شدن امکان سرمایه گذاری هوشمند (پیشنهاد و خرید ترکیب صندوق ها بر اساس شرایط فعلی بازار، سطح ریسک و مدت زمان سرمایه گذاری شما)',
    'اضافه شدن نمایش بازدهی (سود/ زیان) از ابتدا و فعلی صندوق‌های «هر شخص» در صفحه اختصاصی هر صندوق',
    'اضافه شدن نمایش بازدهی (سود/ زیان)  فعلی مجموع صندوق‌های هر شخص در صفحه اول صندوق ها',
    'اضافه شدن امکان انتخاب حساب بانکی برای واریز مبلغ فروش صندوق ها',
    'بهبود رابط کاربری و رفع ایرادات گزارش شده',
  ],
  '1.0.18': [
    'امکان واریز وجه از طریق ثبت فیش بانکی',
    'امکان استعلام وضعیت ارسال مفیدکارت',
    'نمایش وضعیت ثبت نام کاربر در صفحه تکمیل ثبت نام',
    'بهبود رابط کاربری و رفع ایرادات جزیی',
  ],
  '1.0.19': [
    'امکان واریز وجه آنی از طریق درگاه اینترنتی بدون محدودیت سقف واریز وجه',
    'افزایش سقف انتقال از مفیدکارت به کارگزاری به 100 میلیون تومان',
    'بهبود رابط کاربری و رفع ایرادات جزیی',
  ],
  '1.0.20': [
    'اضافه شدن صندوق پیام و اعلانات',
    'امکان استفاده از برخی امکانات اپلیکیشن بدون لاگین',
    'بهبود رابط کاربری و رفع ایرادات جزیی',
  ],
  '1.0.21': [
    'امکان انتقال وجه از حساب ولی به حساب فرزند زیر 18 سال',
    'بهبود رابط کاربری و رفع ایرادات جزیی',
  ],
  '1.0.22': [
    'اضافه‌شدن زبانه کارت، جهت دسترسی راحت‌تر کاربران',
    'نمایش آخرین سود پس‌انداز در صفحه خانه',
    'نمایش تصویری مهم‌ترین تغییرات و قابلیت‌های جدید',
    'اضافه شدن راهنما و سرنخ‌ها، جهت راهنمایی بهتر کاربران',
  ],
  '1.0.23': [
    'بهبود دیزاین صفحه صندوق های سرمایه گذاری',
    'بهبود رابط کاربری و رفع ایرادات جزیی',
  ],
  '1.0.24': ['بهبود رابط کاربری و رفع ایرادات جزئی'],
  '1.0.25': [
    'اضافه شدن قابلیت سرمایه گذاری مستمر و برنامه ریزی شده',
    'امکان سرمایه گذاری مستمر سود ماهانه پس انداز در صندوق های مفید',
    'امکان مشاهده و مدیریت دستگاه های فعال',
    'بهبود رابط کاربری و رفع ایرادات جزئی',
  ],
  '1.0.26': [
    'اضافه شدن قابلیت سرمایه گذاری برای فرزندان',
    'بهبود رابط کاربری و رفع ایرادات جزئی',
  ],
};

export default changelogs;
